var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M76 76L52 52M76 76V56.8M76 76H56.8M4 56.8V76M4 76H23.2M4 76L28 52M76 23.2V4M76 4H56.8M76 4L52 28M4 23.2V4M4 4H23.2M4 4L28 28","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Expand.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
